import { produce } from 'immer';
import { ScopedType, ScopedAsyncType } from './scoped-type';
import { asyncAction } from './async-action';
import { getBannerFor } from '../../services/grower-service';

const Type = ScopedType('ALERT');
const AsyncType = ScopedAsyncType('ALERT');
const SET_ERROR = Type('SET_ERROR');
const SET_INFO = Type('SET_INFO');
const REFRESH_BANNER = AsyncType('REFRESH_BANNER');

export const selectors = {
  error: (state) => state.alert.error,
  info: (state) => state.alert.info,
  banner: (state) => state.alert.banner,
};

export const actions = {
  showError(error) {
    return { type: SET_ERROR, payload: error };
  },

  showInfo(message) {
    return { type: SET_INFO, payload: message };
  },

  refreshBanner(growerId) {
    return asyncAction(REFRESH_BANNER, () => getBannerFor(growerId));
  },
};

const typeReducers = {
  [SET_ERROR]: (state, error) => {
    state.error = error;
  },

  [SET_INFO]: (state, info) => {
    state.info = info;
  },

  [REFRESH_BANNER.start]: (state) => {
    state.banner = null;
  },

  [REFRESH_BANNER.complete]: (state, payload) => {
    state.banner = payload;
  },
};

export const reducers = {
  alert(state = {}, { type, payload } = {}) {
    if (!typeReducers[type]) return state;
    return produce(state, (draft) => typeReducers[type](draft, payload));
  },
};
